export const validateEmail = (email: string): boolean => {
  if (!email) return false;
  return !!String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export const validatePhone = (phone: string) =>
  /^[\d+()\- ]{6,20}$/.test(phone);
export const validateAlphaNumeric = (str: string) => /^[a-zA-Z0-9]*$/.test(str);

export const validateMinLength = (
  value: string,
  minLength: number
): boolean => {
  if (!value || !minLength) return true;
  return value.length >= minLength;
};
